module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('error-dialog-base', {
    ref: "base"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("お使いの端末の"), _c('wbr'), _vm._v("ストレージの空き容量が"), _c('wbr'), _vm._v("不足しています")]), _vm._v(" "), _c("template", {
    tag: "div",
    attrs: {
      "slot": "message"
    },
    slot: "message"
  }, [_vm._v("不要なデータを削除頂く、もしくは他の端末で再度お試しください。")]), _vm._v(" "), _c('div', {
    staticClass: "my-ie-message"
  }, [_c('p', {
    staticClass: "my-ie-message__guide"
  }, [_vm._v("※Internet Explorerをお使いの場合、このエラーはブラウザの設定によって表示されている可能性があります。"), _c('br'), _vm._v("以下の手順をお試しください。")]), _vm._v(" "), _c('ol', {
    staticClass: "my-step-list"
  }, [_c('li', [_vm._v("[インターネットオプション]を開く")]), _vm._v(" "), _c('li', [_vm._v("[全般]タブを開く")]), _vm._v(" "), _c('li', [_vm._v("[閲覧の履歴]の[設定]をクリックする")]), _vm._v(" "), _c('li', [_vm._v("[キャッシュおよびデータベース]タブを開く")]), _vm._v(" "), _c('li', [_vm._v("[Web サイトのキャッシュおよびデータベースを許可する]にチェックを入れる")]), _vm._v(" "), _c('li', [_vm._v("一覧表示の中からWEBサイト「dn-sundai.benesse.ne.jp」をクリックする")]), _vm._v(" "), _c('li', [_vm._v("[制限の拡張]をクリックする")]), _vm._v(" "), _c('li', [_vm._v("[OK]をクリックする")]), _vm._v(" "), _c('li', [_vm._v("ブラウザを再起動する")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c4f12e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/manager/DbManager/dialogs/DialogQuotaExceededError.vue
// module id = 448
// module chunks = 1